export default (state, { configurationError }) => ({
  ...state,
  configurationError,
});
